const initialState = {
    refDataEventsByGroup: [],
};
export default initialState;